/* global $ */
/* eslint react/prop-types: 0 */
/* eslint import/no-unresolved:0 */
/* eslint-disable */

import React from 'react';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from './FooterModalVideoLlamada.css';
import { LOCALSTORAGE_AUTH_KEY } from '../../../../constants/index';
import ImageVolume from '../../../../../public/images/ic_sound.png';
import ImageMax from '../../../../../public/images/ic_maximizar.png';
import ImageClip from '../../../../../public/images/ic_attached.png';
import ImageEstudios from '../../../../../public/images/ic_estudios.png';
import ImageVolumeWhite from '../../../../../public/images/volume-up.png';
import ImageMaxWhite from '../../../../../public/images/expand-arrows.png';
import ImageClipWhite from '../../../../../public/images/paperclip.png';
import ImageEstudiosWhite from '../../../../../public/images/clipboard.png';
import generateAbsoluteUrl from '../../../../utils/generateAbsoluteUrl';

class FooterModalVideoLlamada extends React.Component {
  static ShowPDF(pdf, nombre) {
    //window.open(pdf);
    //return false;
    const temp = Buffer.from(pdf).toString('base64');
    const a = document.createElement('a');
    a.href = `data:application/octet-stream;base64,${temp}`;
    a.download = `${nombre}.pdf`;
    a.click();
  }

  static formatDate(date) {
    const year = date.substr(0, 4);
    const month = date.substr(4, 2);
    const day = date.substr(6, 8);
    const dateFormat = `${day}/${month}/${year}`;
    return dateFormat;
  }

  constructor(props) {
    super(props);

    this.state = {
      // estudios: `<div class="${s.popOverEstudio} row"><div class="col-4">12/06/18</div><div class="col-6" style="padding:0;">Ecocardiografia blablabla</div><div class="col-2"><i class="fa fa-download" aria-hidden="true" /></div></div>`,
      estudios: '',
      download: '',
    };
    this.showDivEstudios = this.showDivEstudios.bind(this);
    this.showVolume = this.showVolume.bind(this);
  }

  componentDidMount() {
    $('body').on('click', function(e) {
      //did not click a popover toggle or popover
      if (
        $(e.target).data('toggle') !== 'popover' &&
        $(e.target).parents('.popover.in').length === 0
      ) {
        $('[data-toggle="popover"]').popover('hide');
      }
    });

    function setVolume(val, video) {
      if (!val) return;
      event.preventDefault();
      let player = document.getElementById(video);
      player.volume = val / 100;
    }

    const datos = JSON.parse(localStorage.getItem(LOCALSTORAGE_AUTH_KEY));
    const datosInteSelected = JSON.parse(localStorage.getItem('inteSelected'));
    const token = datos.token;
    const tipoDoc = datosInteSelected.tipodoc;
    const nroDoc = datosInteSelected.nrodoc;
    const contra = datos.modelEspecifico.contra;
    const inte = datosInteSelected.inte;
    const credencial = datosInteSelected.credencial;
    const fechaNac = datosInteSelected.fechanacimiento;
    const prepaga = datosInteSelected.prepaga;

    const data = {
      contra,
      token,
      inte,
      credencial,
      tipoDoc,
      nroDoc,
      fechaNac,
      prepaga,
    };

    fetch(`${generateAbsoluteUrl()}/api/getEstudios`, {
      
      method: 'POST',
      body: JSON.stringify(data),
      headers: new Headers({
        'Content-Type': 'application/json',
      }),
    })
      .then(res => res.json())
      .then(response => {
        let listEstudios = '';
          if(response.informes){
            for (let i = 0; i < response.informes.length; i += 1) {
              listEstudios += `<div style="margin: 0; border-bottom: 1px solid; border-color: #e6e2e2; padding-top: 10px;" class="col-md-12 row"><div style="padding-bottom: 15px;" class="col-4">${FooterModalVideoLlamada.formatDate(
                response.informes[i].fecha,
              )}</div><div class="col-6" style="padding-bottom: 15px;">${response
                .informes[i]
                .tipo}</div><div class="col-2"><i style=" padding-bottom: 15px; cursor: pointer; font-size: 20px; color: #000;" id="descargar" data-informe=${response
                .informes[i].idInforme} data-imagen=${response.informes[i]
                .idImagen} data-fecha=${response.informes[i]
                .fecha} data-hora=${response.informes[i]
                .hora} class="fa fa-download" aria-hidden="true" /></div></div>`;
            }
          }
        this.setState({ estudios: listEstudios });
      });

    $('#estudiosIcon').popover({
      trigger: 'click',
      html: true,
      container: 'body',
    });

    $('#estudiosIconWhite').popover({
      trigger: 'click',
      html: true,
      container: 'body',
    });

    $('#VolumeIcon').popover({
      trigger: 'click',
      html: true,
      container: 'body',
      template: getPopoverCustomTemplate('myCustomClass'),
    });

    $('#VolumeIconWhite').popover({
      trigger: 'click',
      html: true,
      container: 'body',
      template: getPopoverCustomTemplate('myCustomClass'),
    });

    $('#VolumeIconVideo').popover({
      trigger: 'click',
      html: true,
      container: 'body',
      template: getPopoverCustomTemplate('myCustomClass'),
    });

    function getPopoverCustomTemplate(className) {
      return (
        '<div class="popover ' +
        className +
        '" role="tooltip"><div class="arrow"><div id="divInputVolume"><input style="padding: 5px; margin-top: 5px;" id="vol-control" class=slider type="range" min="0" max="100" value="100" step="1"></input></div></div></div>'
      );
    }

    $('#VolumeIconWhiteVideo').popover({
      trigger: 'click',
      html: true,
      container: 'body',
    });

    $('body').on('click', '#descargar', function(e) {
      e.preventDefault();
      e.stopImmediatePropagation();
      const informe = $(this).data('informe');
      const imagen = $(this).data('imagen');
      const fecha = $(this).data('fecha');
      const hora = $(this).data('hora');

      fetch(`${generateAbsoluteUrl()}/api/getVariablesEntorno`, {
        method: 'POST',
        headers: new Headers({
          'Content-Type': 'application/json',
        }),
      })
        .then(res => res.json())
        .then(response => {
         const apiManagerUrl = response.apiManagerUrl;
         const datos = JSON.parse(localStorage.getItem(LOCALSTORAGE_AUTH_KEY));
         const token = datos.token;
         const dataDownload = {
           contra,
           token,
           inte,
           credencial,
           tipoDoc,
           nroDoc,
           fechaNac,
           prepaga,
           informe,
           imagen,
           fecha,
           hora,
         };
   
         let xhr = new XMLHttpRequest();
         const uri = `${apiManagerUrl}/api-smg/v0/pacientes/${contra}/integrantes;nacimiento=${fechaNac};documento=${nroDoc}/${inte}/estudios/clinica/informes/${informe}/imagen/${imagen}?fecha=${fecha}&hora=${hora}`;
         //const uri = `https://mobileqa.swissmedical.com.ar/api-smg/v0/pacientes/${contra}/integrantes;nacimiento=${fechaNac};documento=${nroDoc}/${inte}/estudios/clinica/informes/${informe}/imagen/${imagen}?fecha=${fecha}&hora=${hora}`;
         console.log(uri);
       
       //set the request type to post and the destination url to '/convert'
       xhr.open('GET', uri);
   
       xhr.setRequestHeader("Authorization", `Bearer ${token}`);
       //set the reponse type to blob since that's what we're expecting back
       xhr.responseType = 'blob';
       let formData = new FormData(this);
       xhr.send(formData); 
       xhr.onload = function(e) {
           if (this.status == 200) {
               // Create a new Blob object using the response data of the onload object
               var blob = new Blob([this.response], {type: 'image/pdf'});
               //Create a link element, hide it, direct it towards the blob, and then 'click' it programatically
               let a = document.createElement("a");
               a.style = "display: none";
               document.body.appendChild(a);
               //Create a DOMString representing the blob and point the link element towards it
               let url = window.URL.createObjectURL(blob);
               a.href = url;
               a.download = `estudio_${informe}.pdf`;
               //programatically click the link to trigger the download
               a.click();
               //release the reference to the file by revoking the Object URL
               window.URL.revokeObjectURL(url);
           }else{
               //deal with your error state here
           }
       };
     });
   });

    $('body').on('change', '#vol-control', function(event) {
      setVolume(this.value, 'videoSwiss');
    });

    $('body').on('input', '#vol-control', function(event) {
      setVolume(this.value, 'videoSwiss');
    });

    $('body').on('change', '#vol-control', function(event) {
      setVolume(this.value, 'remoteView');
    });

    $('body').on('input', '#vol-control', function(event) {
      setVolume(this.value, 'remoteView');
    });
  }

  showVolume() {
    if ($('#divInputVolume').is(':visible')) {
      $('#divInputVolume').hide();
    } else {
      $('#divInputVolume').show();
    }
  }

  showDivEstudios() {
    let estudios = '';
    if ($('#divEstudios').is(':visible')) {
      $('#divEstudios').hide();
    } else {
      estudios = this.state.estudios;
      const estudiosHeader = `<div style="background-color:#f1f1f1; color: #000; text-align: left;"><b>Estudios realizados</b></div>${estudios}`;
      $('#divEstudios').html(estudiosHeader);
      $('#divEstudios').show();
    }
  }
  componentWillReceiveProps() {}

  componentWillUnmount() {}

  render() {
    const estudios = this.state.estudios;
    return this.props.llamadaIniciada
      ? <div className={`${s.footerContent} row`}>
          <div style={{ width: '96%' }}>
            <img
              alt="Anterior"
              src={ImageEstudios}
              className="fa fa-calendar-o"
              aria-hidden="true"
              data-toggle="popover"
              data-placement="top"
              title="Estudios realizados"
              data-content={estudios}
              data-container="body"
              id="estudiosIcon"
              style={{ cursor: 'pointer', marginRight: '25px' }}
            />
            <img
              id="modalClip"
              alt="Anterior"
              src={ImageEstudiosWhite}
              className="fa fa-calendar-o"
              aria-hidden="true"
              onClick={this.showDivEstudios}
              //data-toggle="popover"
              //data-placement="top"
              //title="Estudios realizados"
              //data-content={estudios}
              //data-container="body"
              id="estudiosIconWhite"
              style={{
                cursor: 'pointer',
                marginRight: '25px',
                display: 'none',
              }}
            />
            <label htmlFor="fileInput" style={{ marginBottom: '0' }}>
              <img
                id="modalClip"
                alt="Anterior"
                src={ImageClip}
                style={{ cursor: 'pointer', marginRight: '25px' }}
              />
              <img
                id="modalClipWhite"
                alt="Anterior"
                src={ImageClipWhite}
                style={{
                  cursor: 'pointer',
                  marginRight: '25px',
                  display: 'none',
                }}
              />
            </label>
            <input
              id="fileInput"
              type="file"
              className={s.fileUpload}
              onChange={this.props.getPhoto}
              // onChange={this.onChange}
            />{' '}
            <img
              alt="Anterior"
              src={ImageVolume}
              data-toggle="popover"
              data-placement="top"
              id="VolumeIcon"
              data-content="<input id=&quot;vol-control-video&quot; class=slider type=&quot;range&quot; min=&quot;0&quot; max=&quot;100&quot; step=&quot;1&quot;></input>"
              style={{ cursor: 'pointer', marginRight: '25px' }}
            />
            <img
              alt="Anterior"
              src={ImageVolumeWhite}
              //data-toggle="popover"
              //data-placement="top"
              id="VolumeIconWhite"
              //data-content='<input id="vol-control-video" class=slider type="range" min="0" max="100" step="1"></input>'
              style={{
                cursor: 'pointer',
                marginRight: '25px',
                display: 'none',
              }}
              onClick={this.showVolume}
            />
            <img alt="Anterior" src={ImageVolumeWhite} 
              data-toggle="popover"
              data-placement="top"
              id="VolumeIconWhite"
              data-content='<input id="vol-control-video" class=slider type="range" min="0" max="100" step="1"></input>'
              style={{ cursor: 'pointer', marginRight: '25px', display: 'none'}}
            />
            <img
              alt="Anterior"
              src={ImageMax}
              onClick={this.props.maximizeModalVideoLlamada}
              id="modalMaximize"
              style={{ cursor: 'pointer' }}
            />
            <img
              alt="Anterior"
              src={ImageMaxWhite}
              onClick={this.props.restoreModalVideoLlamada}
              id="modalRestore"
              style={{ cursor: 'pointer', display: 'none' }}
            />
            <div
              id="divInputVolume"
              style={{
                display: 'none',
                position: 'absolute',
                right: '20px',
                bottom: '31px',
                width: '130px',
                height: '40px',
                backgroundColor: '#fff',
                borderRadius: '.3rem',
              }}
            >
              <input
                style={{ marginTop: '8px' }}
                id="vol-control"
                className="slider"
                type="range"
                min="0"
                max="100"
                step="1"
                defaultValue="100"
              />
            </div>
            <div
              id="divEstudios"
              className={`${s.modalEstudios}`}
              style={{
                display: 'none',
                position: 'absolute',
                right: '20px',
                bottom: '30px',
                maxWidth: '375px',
                maxHeight: '550px',
                color: '#6f6b6b',
                backgroundColor: '#fff',
                borderRadius: '.3rem',
                overflow: 'auto',
                fontSize: '.875rem',
                fontFamily: 'font-family: Roboto',
              }}
            />
          </div>
        </div>
      : <div className={`${s.footerContent} row`}>
          <div style={{ width: '96%' }}>
            <img
              className={` ${s.popoverVolume}`}
              alt="volume"
              src={ImageVolume}
              style={{ marginRight: '30px', cursor: 'pointer' }}
              data-toggle="popover"
              data-placement="top"
              id="VolumeIconVideo"
              data-content="<input id='vol-control' class='slider' type='range' min='0' max='100' value='100' step='1'></input>"
            />
            <img
              alt="volume"
              src={ImageVolumeWhite}
              style={{
                marginRight: '30px',
                cursor: 'pointer',
                display: 'none',
              }}
              data-toggle="popover"
              data-placement="top"
              id="VolumeIconWhiteVideo"
              data-content="<input id=&quot;vol-control&quot; class=slider type=&quot;range&quot; min=&quot;0&quot; max=&quot;100&quot; step=&quot;1&quot;></input>"
            />
            <img
              alt="volume"
              src={ImageVolumeWhite}
              style={{ marginRight: '30px', cursor: 'pointer', display: 'none'}}
              data-toggle="popover"
              data-placement="top"
              id="VolumeIconWhite"
              data-content='<input id="vol-control" class=slider type="range" min="0" max="100" step="1"></input>'
            />
            <img
              alt="Anterior"
              src={ImageMax}
              onClick={this.props.maximizeModalVideoLlamada}
              id="modalMaximize"
              style={{ cursor: 'pointer' }}
            />
            <img
              alt="Anterior"
              src={ImageMaxWhite}
              onClick={this.props.restoreModalVideoLlamada}
              id="modalRestore"
              style={{ cursor: 'pointer', display: 'none' }}
            />
         </div>
        </div>;
  }
}
/*
const mapStateToProps = state => ({
  fileuploadStatus: state.telemedicina.fileuploadStatus,
});
*/
export default withStyles(s)(FooterModalVideoLlamada);



// WEBPACK FOOTER //
// ./src/components/Telemedicina/ModalVideoLlamada/FooterModalVideoLlamada/FooterModalVideoLlamada.js